module.exports = __webpack_public_path__ + "static/img/anquanlvsezhengban.9f66467.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/anquanlvsezhengban.png
// module id = uKnj
// module chunks = 31